<template>
  <div>
    <div class="marginCenter">
      <div class="applyType flex-center">
        <span class="fsize24">请选择申请类型：</span>
        <el-select v-model="trainType" placeholder="请选择">
          <el-option
            v-for="item in dict.type.train_type"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="flex-xCenter fsize16 remark">
        {{ remark }}
      </div>
      <div class="flex-xCenter">
        <el-button type="primary" class="blueBtn2 btn300" @click="next"
          >下一步</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  dicts: ["train_type"],
  components: {},
  data() {
    return {
      trainType: "",
      remark: "",
      strogeId:0
    };
  },
  created() {
    this.getConfigKey("train.trainTypeDurationDesc").then((response) => {
      this.remark = response.msg;
    });
  },
  mounted() {},
  methods: {
    next() {
      if(this.trainType == '') return
      this.$emit('getStroge',this.trainType)
       this.$emit('getStroge',this.trainType)
      this.$parent.isNurse = this.trainType ;
      console.log(this.trainType,49)
      
    },
  },
};
</script>
<style lang="scss" scoped>
.el-button--primary {
  padding: 0;
}
.backIndex:hover {
  cursor: pointer;
}
.applyType {
  margin-top: 110px;
}
.remark {
  margin: 32px 0 110px 0;
}
</style>
